import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import { provideAttachmentPdfRefresh } from '@core/attachments-logic';
import type { Attachment } from '@core/attachments-types';
import { AttachmentItemComponent } from '@core/attachments-ui';

@Component({
  selector: 'rt-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AttachmentItemComponent],
  providers: [provideAttachmentPdfRefresh()],
})
export class AttachmentsListComponent {
  public readonly attachments = input<Attachment[]>(undefined!);
  public readonly deletable = input<boolean>(false);
  public readonly small = input<boolean>(false);
  public readonly candidateActionsEnabled = input<boolean>(false);
  public readonly moreTemplate = input<TemplateRef<any>>(undefined!);
  public readonly hasSetAsCoverLetterAction = input<boolean>(false);
  public readonly canManageCandidates = input(false);
  public deleteClick = output<Attachment>();
  public setAsCv = output<Attachment>();
  public setAsCoverLetter = output<Attachment>();

  public trackByAttachment(index: number, attachment: Attachment): number {
    return attachment.id;
  }
}
